export default __webpack_public_path__ + "static/media/circle-o-tick-tangerine.af22ae40.svg";